import * as React from 'react';
import {withStyles, createStyles} from '@material-ui/core/styles';
const ReactImg = require('react-image');
import {WithStyles} from '@material-ui/core/styles/withStyles';
import * as classNames from 'classnames';
import {Overwrite} from 'utility-types';
import {getResizeUrl} from '../../../MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import * as _ from 'lodash';
export enum IMG_SIZES {
  Thumbnail = 'thumbnail',
  Mini = 'mini',
}

type ImgProps = Overwrite<React.ImgHTMLAttributes<HTMLImageElement>, {src?: string | Array<string | null>}> &
  WithStyles<'root' | 'thumbnail' | 'mini'> & {
    size?: IMG_SIZES;
    loader?: React.ReactElement<any>;
    unloader?: React.ReactElement<any>;
  };

const Img: React.FunctionComponent<ImgProps> = React.forwardRef(
  ({loader, unloader, className, classes, size, src, ...props}, ref) => {
    const computedClassName = classNames({
      [className]: !!className,
      [classes.root]: true,
      [classes.thumbnail]: size === IMG_SIZES.Thumbnail,
      [classes.mini]: size === IMG_SIZES.Mini,
    });
    unloader = unloader ? React.cloneElement(unloader, {className: computedClassName}) : undefined;
    if (!loader && size) {
      loader = <div className={computedClassName} />;
    }
    if (!unloader && size) {
      unloader = <div className={computedClassName} />;
    }
    switch (size) {
      case IMG_SIZES.Mini:
        if (_.isArray(src)) {
          src = src.map(src => getResizeUrl(src, {width: 32}));
        } else {
          src = getResizeUrl(src, {width: 32});
        }
        break;
      case IMG_SIZES.Thumbnail:
        if (_.isArray(src)) {
          src = src.map(src => getResizeUrl(src, {width: 48}));
        } else {
          src = getResizeUrl(src, {width: 48});
        }
        break;
      default:
        break;
    }
    return (
      <ReactImg.default
        ref={ref}
        className={computedClassName}
        unloader={unloader}
        loader={loader}
        src={src}
        {...props}
      />
    );
  }
);

const style = createStyles({
  [`@keyframes fadeIn`]: {
    from: {opacity: 0},
    to: {opacity: 1},
  },
  thumbnail: {
    width: 48,
    height: 48,
    objectFit: 'cover',
    flexShrink: 0,
  },
  mini: {
    width: 32,
    height: 32,
    objectFit: 'cover',
    flexShrink: 0,
  },
  root: {
    maxWidth: 'initial',
    animation: `$fadeIn 100ms ease-out`,
  },
});
export default withStyles(style)(Img);
